<template>
  <section id="admin-overview">
    <v-layout row wrap align-content-center justify-center>
      <v-flex xs12>
        <section class="section-header" row wrap align-content-center justify-center>
          <h1 class="section-title">
            <v-icon color="deep-orange darken-2">fal fa-smile</v-icon>
            Olá, {{ user.first_name }}!
          </h1>
        </section>
      </v-flex>
      <v-flex xs12 md3>
        <div class="section-box text-xs-center section-widget">
          <div><v-icon>fal fa-users</v-icon></div>
          <span class="number teal--text" v-if="overview.users_count && overview.users_count.length">
            {{ overview.users_count.length | formatNumber }}
          </span>
          <h2 class="section-title">ALUNOS</h2>
        </div>
      </v-flex>
      <v-flex xs12 md3>
        <div class="section-box text-xs-center section-widget">
          <div><v-icon>fal fa-dumbbell</v-icon></div>
          <span class="number teal--text">{{ overview.trainings_count | formatNumber }}</span>
          <h2 class="section-title">TREINOS</h2>
        </div>
      </v-flex>
      <v-flex xs12 md3>
        <div class="section-box text-xs-center section-widget">
          <div><v-icon>fal fa-stopwatch</v-icon></div>
          <span class="number teal--text">{{ overview.exercises_count | formatNumber }}</span>
          <h2 class="section-title">EXERCÍCIOS</h2>
        </div>
      </v-flex>
      <v-flex xs12 md3>
        <div class="section-box text-xs-center section-widget">
          <div><v-icon>fal fa-usd-circle</v-icon></div>
          <span class="number teal--text">-</span>
          <h2 class="section-title">SALDO</h2>
        </div>
      </v-flex>
    </v-layout>
  </section>
</template>

<script>
import axios from 'axios'
import EventBus from '@/event-bus'

export default {
  data: () => ({
    user: JSON.parse(localStorage.getItem('currentUser')),
    overview: {}
  }),

  methods: {
    loadOverview () {
      EventBus.$emit('appLoading', true)
      // eslint-disable-next-line
      let path = API.overview

      axios.get(path).then(response => {
        this.overview = response.data
        EventBus.$emit('appLoading', false)
      }).catch(errors => {
        EventBus.$emit('appLoading', false)
      })
    }
  },

  created () {
    this.loadOverview()
  }
}
</script>

<style src="../../assets/scss/components/overview.scss" lang="scss"></style>



// WEBPACK FOOTER //
// src/components/admin/AdminOverview.vue